import React from 'react';
import compose from '../../utils/compose';
import wrapSchemaWidget from './wrapSchemaWidget';
import SelectInput from '../../Inputs/FilterSelectTypeahead/FilterSelectTypeahead';
import wrapUiDisabledWidget from './wrapUiDisabledWidget';
import { makeSelectWidget } from './SelectWidget';
export default compose(wrapUiDisabledWidget, wrapSchemaWidget)(makeSelectWidget(SelectInput));